// 26.1.11 Reflect.ownKeys(target)
var $export = require('./$.export');

$export($export.S, 'Reflect', {ownKeys: require('./$.own-keys')});


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es6.reflect.own-keys.js
// module id = 450
// module chunks = 0 1